var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_148166",
    "data-name": "Group 148166",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 13,
    cy: 13,
    r: 13,
    transform: "translate(0 1)",
    fill: "#125bb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M6.97,7.841A3.921,3.921,0,1,0,3.049,3.921,3.922,3.922,0,0,0,6.97,7.841Zm3.485.871h-1.5a4.739,4.739,0,0,1-3.97,0h-1.5A3.485,3.485,0,0,0,0,12.2v.436A1.307,1.307,0,0,0,1.307,13.94H12.633a1.307,1.307,0,0,0,1.307-1.307V12.2A3.485,3.485,0,0,0,10.455,8.712Z",
    transform: "translate(6 7)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.46329f36473c4d927abd23cca33c0045.svg";
export { ForwardRef as ReactComponent };